import Modal from "../classes/modal";

export default function attachment_page() {
  if (window.location.href.indexOf("/attachment") === -1) return;
  const modal = new Modal;
  document.addEventListener('click', e => {
    if (e.target.classList.contains('inner-page__layout-item')) {
      modal.displayImageModal(e.target.getAttribute('data-src'));
    } else {
      document.querySelector('.modal')?.parentElement.remove();
    }
  })
}
